import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { User, Stethoscope } from "lucide-react";

interface UserTypeSelectorProps {
  userType: string;
  onUserTypeChange: (value: string) => void;
}

export const UserTypeSelector = ({ userType, onUserTypeChange }: UserTypeSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label>Type de compte</Label>
      <RadioGroup
        value={userType}
        onValueChange={onUserTypeChange}
        className="flex gap-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="patient" id="patient" />
          <Label htmlFor="patient" className="flex items-center gap-1">
            <User className="h-4 w-4" />
            Patient
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="professional" id="professional" />
          <Label htmlFor="professional" className="flex items-center gap-1">
            <Stethoscope className="h-4 w-4" />
            Professionnel de santé
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};